import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminRelayEntriesDetailOverride from './UseOrgUnitAdminRelayEntriesDetailOverride';

import OrgUnitAdminRelayEntryOverrideSelectionGrid from './OrgUnitAdminRelayEntryOverrideSelectionGrid';

import EventMeetEventDropdown from '../../../../components/dropdowns/EventMeetEventDropdown';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import TimeInput from '@usas/ui-web/components/inputs/TimeInput';
import DatePicker from '@usas/ui-web/components/datepickers/DatePicker';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import Input from '@usas/ui-web/components/inputs/Input';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import Constants from '@usas/ui-web/utils/Constants';

const OrgUnitAdminRelayEntriesDetailOverride = () => {
  const { state, gridState, calculatedTeamEntryTimeState, isLarge, omeMeetState, omeMeetOrgUnitEntryId, relayTeamOptionsState, omeMeetOrgUnitAthleteEntryRelayRosterEntryState,
    onSaveClicked, onBackClicked, onValueTextPairChanged, onFormValueChanged, formState, errorState, MSG, omeMeetOrgUnitAthleteEntryAggregateRelayAthleteState, eventMeetEventState,
    setHandleEventChange } = useOrgUnitAdminRelayEntriesDetailOverride();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_MANAGE_RELAY_TEAM_OVERRIDE}
        onNextButtonClicked={onSaveClicked}
        onBackButtonClicked={onBackClicked}
        errorMessage={errorState.general}>
        <div className="row">
          <div className="col-xs-12 usas-extra-bottom-margin">
            <p className={global.HeaderText}><b>Relay Event:</b> {state.event?.eventName || ''} ({state.event?.eventCompetitionGenderTypeName || ''}, {state.event?.ageGroupName || ''}), Session {state.event?.meetSessionName || ''}</p>
            {(state.event?.timeCuts && state.event?.timeCuts.length > 0) && formState.hasQualifyingWindow === true &&
              <p className={global.HeaderText}><b>Qualifying Date Range:</b> {`${formState.qualifyingStartDate} - ${formState.qualifyingEndDate}`}</p>}
          </div>
        </div>
        <form>
          <div className='row'>
            <div className="col-xs-12 col-sm-4">
              <YesNoSwitch
                label="Add Relay Via Aggregate?"
                name="isAggregate"
                checked={formState.isAggregate}
                error={errorState.isAggregate}
                message={errorState.isAggregate}
                onChange={(value) => { onFormValueChanged('isAggregate', value) }} />
            </div>
            <div className="col-xs-12 col-sm-8">
              <Dropdown
                label="Relay Team Name*"
                name="relayTeamId"
                options={relayTeamOptionsState.options}
                value={formState.relayTeamId}
                error={errorState.relayTeamId}
                message={errorState.relayTeamId}
                isLoading={false}
                onChange={(newValue, newValueLabel, e) => {
                  e && e.target && e.target.value &&
                    onValueTextPairChanged(newValue, 'relayTeamId', newValueLabel, 'relayTeamName');
                }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <EventMeetEventDropdown
                label="Event*"
                name="eventId"
                value={formState.eventId}
                error={errorState.eventId}
                message={errorState.eventId}
                onChange={(value, newValueLabel, e) => {
                  e && e.target && e.target.value &&
                    setHandleEventChange(true);
                  onValueTextPairChanged(value, 'eventId', newValueLabel, 'eventName')
                }}
                meetEventId={state.event?.meetEventId}
              />
            </div>
            {formState.isAggregate === false &&
              <div className={formState.isAggregate === false ? global.DisplayComponent : global.HideComponent}>
                <div className="col-xs-12 col-sm-6 col-md-4">
                  <TimeInput
                    label="Swim Time*"
                    name="swimTime"
                    value={formState.swimTime}
                    error={errorState.swimTime}
                    message={errorState.swimTime}
                    onChange={(displayValue, value) => { onValueTextPairChanged(displayValue, 'swimTime', value, 'swimTimeValue'); }} />
                </div>
              </div>}
            {formState.isAggregate === false &&
              <div className={formState.isAggregate === false ? global.DisplayComponent : global.HideComponent}>
                <div className="col-xs-12 col-sm-6 col-md-4">
                  <DatePicker
                    label="Swim Date*"
                    name="swimDate"
                    value={formState.swimDate}
                    error={errorState.swimDate}
                    message={errorState.swimDate}
                    onChange={(value) => { onFormValueChanged('swimDate', value); }} />
                </div>
                <div className="col-xs-12 col-sm-6 col-md-4">
                  <Input
                    label={"Meet Name*"}
                    name="meetName"
                    value={formState.meetName}
                    error={errorState.meetName}
                    message={errorState.meetName}
                    onChange={(value) => { onFormValueChanged('meetName', value) }} />
                </div>
              </div>}
          </div>
          {formState.isAggregate === true &&
            <div className={formState.isAggregate === true && formState.eventId !== Constants.DEFAULT_ID ? global.DisplayComponent : global.HideComponent}>
              <div className="row">
                <div className="col-xs-12 usas-extra-top-margin">
                  <p className={global.HeaderText}><b>Team Entry Time:</b> {calculatedTeamEntryTimeState.entryTime || 'NT'}  {calculatedTeamEntryTimeState.entryTime !== MSG && calculatedTeamEntryTimeState.entryTime && formState.courseCode ? formState.courseCode : ''}</p>
                </div>
                <div className="col-xs-12">
                  <p><b>For their name to appear as a relay leg option, an athlete{omeMeetState?.objData.omeMeetEligibility[0]?.relayTeamFromRosterOnly === true ? ' must be on the roster and' : ''} cannot be associated with an exisiting relay team for the event</b></p>
                </div>
                <div className=" col-xs-12 usas-extra-bottom-margin">
                  <OrgUnitAdminRelayEntryOverrideSelectionGrid
                    gridData={gridState.gridData}
                    isLoading={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading}
                    meetEventId={state.event?.meetEventId}
                    omeMeetOrgUnitEntryId={omeMeetOrgUnitEntryId}
                    formState={formState}
                    errorState={errorState}
                    onValueTextPairChanged={onValueTextPairChanged}
                    onFormValueChanged={onFormValueChanged}
                    isLarge={isLarge}
                  />
                </div>
              </div>
            </div>}
        </form>
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitAthleteEntryAggregateRelayAthleteState.isObjLoading || eventMeetEventState.isArrayLoading} />
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isSaving} />
      </ViewTemplate >
    </Fragment >
  );
};

export default OrgUnitAdminRelayEntriesDetailOverride;